/* <ebc-variant-root> — swaps the EBC stack when the selected variant changes.
   Rendered by sections/ebc-images.liquid only when at least one variant has
   its own custom.ebc_slots. Re-fetches the section for the new variant via
   the Section Rendering API (the Liquid already handles variant → product
   fallback) and replaces this element's contents. Responses are cached per
   variant so switching back and forth is instant.
   Only this product's own variants trigger a swap: the multipack Pack
   selector puts a separate bundle product's variant id into the cart form,
   and a pack change should keep the current size's EBC. */

(function () {
  if (customElements.get('ebc-variant-root')) return;

  class EbcVariantRoot extends HTMLElement {
    connectedCallback() {
      this.currentVariantId = this.dataset.variantId;
      this.cache = new Map();
      this.variantIds = new Set((this.dataset.variantIds || '').split(',').filter(Boolean));
      this.onVariantId = this.onVariantId.bind(this);

      // Main signal: theme pub/sub, published after the product info refresh.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event && event.data && event.data.variant;
          if (variant) this.onVariantId(String(variant.id));
        });
      }

      // Fallback: any product form's hidden variant id input changing.
      this.onFormChange = (event) => {
        const target = event.target;
        if (target && target.matches && target.matches('form[action*="/cart/add"] [name="id"]') && target.value) {
          this.onVariantId(String(target.value));
        }
      };
      document.addEventListener('change', this.onFormChange);
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      document.removeEventListener('change', this.onFormChange);
    }

    onVariantId(variantId) {
      if (!variantId || variantId === this.currentVariantId) return;
      if (!this.variantIds.has(variantId)) return; // e.g. a multipack bundle variant
      this.currentVariantId = variantId;

      this.fetchMarkup(variantId)
        .then((markup) => {
          // A newer selection may have happened while this request was in flight.
          if (markup == null || variantId !== this.currentVariantId) return;
          this.innerHTML = markup;
        })
        .catch((e) => console.error(e));
    }

    fetchMarkup(variantId) {
      if (this.cache.has(variantId)) return Promise.resolve(this.cache.get(variantId));

      const url = `${this.dataset.url}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(this.dataset.sectionId)}`;
      return fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const source = html.querySelector('ebc-variant-root');
          const markup = source ? source.innerHTML : null;
          this.cache.set(variantId, markup);
          return markup;
        });
    }
  }

  customElements.define('ebc-variant-root', EbcVariantRoot);
})();
